import { useVideoConfig, OffthreadVideo, Audio } from "remotion";
import { VideoSegmentMultiFocusDesignSystemConfig } from "../../VideoSegmentMultiFocus";
import { BorderWrapper } from "../utils/borderStyle";

export const DefaultFocusVideoSegment: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = ({ 
    startTimestampMS, 
    endTimestampMS, 
    videoURL, 
    spacing: padding, 
    borderRadius, 
    border, 
    borderStyle,
    audioURL 
}) => {
    const { width, height, fps } = useVideoConfig();

    const paddingSize = padding ? Math.sqrt(width * height) * 0.05 : 0;
    const borderThickness = border ? Math.sqrt(width * height) / 150 : 0;

    console.log(audioURL);
    return (
        <div style={{ margin: paddingSize }}>
            <BorderWrapper 
                borderStyle={borderStyle}
                borderThickness={borderThickness}
                borderRadius={borderRadius}
            >
                <OffthreadVideo
                    src={videoURL}
                    startFrom={startTimestampMS / 1000 * fps}
                    endAt={endTimestampMS / 1000 * fps}
                    style={{
                        objectFit: 'scale-down',
                        transformOrigin: 'center center',
                    }}
                    muted={audioURL == undefined ? false : true}
                />
                {audioURL && <Audio src={audioURL} />}
            </BorderWrapper>
        </div>
    )
}